import { LAST_7_DAYS } from 'constants/influencerReporting';
import {
  DISCARD_SHOPPABLE_POST_DETAILS,
  EDIT_SHOPPABLE_POST_CAPTION,
  EDIT_SHOPPABLE_POST_TITLE,
  REQUEST_INFLUENCER_DETAILS,
  SET_INFLUENCER_APP_CONFIG,
  SET_INFLUENCER_BIO,
  SET_INFLUENCER_COLLECTION_BANNER,
  SET_INFLUENCER_COLLECTION_REPORT,
  SET_INFLUENCER_DETAILS,
  SET_INFLUENCER_DRAFT,
  SET_INFLUENCER_NAME,
  SET_INFLUENCER_PRODUCT_REPORT,
  SET_INFLUENCER_PROFILE_HANDLE,
  SET_INFLUENCER_REPORT_PERIOD_SELECTION,
  SET_INFLUENCER_REPORT_VIEW,
  SET_INFLUENCER_STYLES,
  SET_INFLUENCER_SUMMARY_REPORT,
  SET_INFLUENCER_SYMPHONY_SLOTS,
  SET_INFLUENCER_TOKEN,
  SET_IS_INFLUENCER_REPORT_LOADING,
  SET_IS_INFLUENCER_STATUS,
  SET_SHOPPABLE_MEDIA_PHYSICAL_ID,
  SET_SHOPPABLE_POST_INFO,
  SET_SHOPPABLE_POST_TITLE_AND_ID,
  SET_SHOW_INFLUENCER_HUB,
  TOGGLE_INFLUENCER_SAVE_DRAFT
} from 'constants/reduxActions';
import { InfluencerStatus } from 'types/influencer';

const initialState = {
  status: InfluencerStatus.UNKNOWN,
  socialMediaProfiles: {},
  name: '',
  profileBio: '',
  stylesList: [],
  profileHandle: '',
  isLoading: false,
  isInfluencer:false,
  showInfluencerHub:false,
  influencerToken: '',
  applyWithOtherAccount: false,
  creationDate: 0,
  influencerCreationDays: 0,
  summaryReport:{},
  collectionReport:{},
  productReport:{},
  displayCollectionReport: false,
  displayProductReport: false,
  displaySummaryReport: false,
  currentCollectionReportPage: 1,
  currentProductReportPage: 1,
  totalCollectionReportPages: 0,
  totalProductReportPages: 0,
  reportView: 'Products',
  showCollectionBanner: true,
  selectedReportDuration: LAST_7_DAYS,
  isReportLoading: false,
  isProfileIncomplete: false,
  draft: { data: null, save: false },
  influencerId: ''
};

export default function influencer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_INFLUENCER_DETAILS:
      return { ...state, isLoading: true };
    case SET_INFLUENCER_APP_CONFIG:
      const { appConfig } = action;
      return { ...state, appConfig };
    case SET_IS_INFLUENCER_STATUS:
      let { status } = action;
      if (status === null) {
        status = InfluencerStatus.NULL;
      }
      const isInfluencer = status === InfluencerStatus.ACTIVE;
      return { ...state, status, isInfluencer };
    case TOGGLE_INFLUENCER_SAVE_DRAFT: {
      const { canSave } = action;

      return {
        ...state,
        draft: {
          data: {},
          save: canSave
        }
      };
    }
    case SET_INFLUENCER_DRAFT: {
      const { draft: { influencerName: name, influencerBio: profileBio, influencerStyleList: stylesList } } = action;

      if (!state.draft.save) {
        return state;
      }

      return {
        ...state,
        draft: {
          data: {
            name,
            profileBio,
            stylesList
          },
          save: state.draft.save
        }
      };
    }
    case SET_INFLUENCER_DETAILS:
      const { influencerDetails } = action;
      const socialMediaProfileMap = {};
      if (influencerDetails && influencerDetails.details) {
        influencerDetails.details.socialMediaProfiles.forEach(profile => {
          socialMediaProfileMap[profile.profileType] = profile;
        });
      }
      const isProfileIncomplete = !influencerDetails.details.name || !influencerDetails.details.stylesList.length;
      return {
        ...state,
        socialMediaProfiles: socialMediaProfileMap,
        name: influencerDetails.details.name || initialState.name,
        stylesList: influencerDetails.details.stylesList || initialState.stylesList,
        profileBio: influencerDetails.details.profileBio || initialState.profileBio,
        profileHandle: influencerDetails.details.profileHandle || initialState.profileHandle,
        status: influencerDetails.details.status,
        creationDate: influencerDetails.details.creationDate,
        influencerCreationDays: influencerDetails.details.influencerCreationDays,
        influencerId: influencerDetails.details.customerId,
        isProfileIncomplete,
        isLoading:false
      };
    case SET_INFLUENCER_BIO:
      const { profileBio } = action;
      return {
        ...state,
        profileBio
      };
    case SET_INFLUENCER_STYLES:
      const { stylesList } = action;
      return {
        ...state,
        stylesList
      };
    case SET_INFLUENCER_NAME:
      const { name } = action;
      return {
        ...state,
        name
      };
    case SET_INFLUENCER_PROFILE_HANDLE:
      const { profileHandle } = action;
      return {
        ...state,
        profileHandle
      };
    case SET_INFLUENCER_TOKEN:
      const { influencerToken } = action;
      return { ...state, influencerToken };
    case SET_SHOW_INFLUENCER_HUB:
      const { status: influencerStatus } = action;
      const showInfluencerHub = influencerStatus === InfluencerStatus.PENDING
        || influencerStatus === InfluencerStatus.ACTIVE ;
      return { ...state, status:influencerStatus, showInfluencerHub };
    case SET_INFLUENCER_COLLECTION_REPORT:
      const { collectionReport, currentCollectionReportPage, totalCollectionReportPages, displayCollectionReport } = action;
      return { ...state, collectionReport, currentCollectionReportPage, totalCollectionReportPages, displayCollectionReport };
    case SET_INFLUENCER_PRODUCT_REPORT:
      const { productReport, currentProductReportPage, totalProductReportPages, displayProductReport } = action;
      return { ...state, productReport, currentProductReportPage, totalProductReportPages, displayProductReport };
    case SET_INFLUENCER_SUMMARY_REPORT:
      const { summaryReport, displaySummaryReport } = action;
      return { ...state, summaryReport, displaySummaryReport };
    case SET_INFLUENCER_SYMPHONY_SLOTS:
      const { data: { slotData, slotNames } } = action;
      return { ...state, collectionCreatives: { slotData, slotNames } };
    case SET_INFLUENCER_COLLECTION_BANNER:
      const { showCollectionBanner } = action;
      return { ...state, showCollectionBanner };
    case SET_INFLUENCER_REPORT_PERIOD_SELECTION:
      const { duration } = action;
      return { ...state, selectedReportDuration: duration };
    case SET_IS_INFLUENCER_REPORT_LOADING:
      const { isReportLoading } = action;
      return { ...state, isReportLoading };
    case SET_INFLUENCER_REPORT_VIEW:
      const { reportView } = action;
      return { ...state, reportView };
    case SET_SHOPPABLE_POST_TITLE_AND_ID:
      const { postTitle, postId } = action;
      return { ...state, shoppablePost: { postTitle, postId } };
    case SET_SHOPPABLE_POST_INFO:
      const { shoppablePost } = action;
      return { ...state, shoppablePost };
    case SET_SHOPPABLE_MEDIA_PHYSICAL_ID:
      const { mediaPhysicalId } = action;
      const { shoppablePost: currentShoppablePost } = state;
      const newShoppablePost = { ...currentShoppablePost, mediaPhysicalId };
      return { ...state, newShoppablePost };
    case DISCARD_SHOPPABLE_POST_DETAILS:
      return { ...state, shoppablePost: {} };
    case EDIT_SHOPPABLE_POST_TITLE:
      const { newPostTitle } = action;
      return { ...state, shoppablePost: { ...state.shoppablePost, postTitle: newPostTitle } };
    case EDIT_SHOPPABLE_POST_CAPTION:
      const { newPostCaption } = action;
      return { ...state, shoppablePost: { ...state.shoppablePost, postCaption: newPostCaption } };
    default:
      return state;
  }
}
